// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsonCodec from "../../primitives/JsonCodec.res.js";
import * as QueryString from "../../primitives/QueryString.res.js";

function encoder(param) {
  return [
    param.supplierId,
    param.shopId
  ];
}

function decoder(param) {
  return {
    TAG: "Ok",
    _0: {
      supplierId: param[0],
      shopId: param[1]
    }
  };
}

let value = JsonCodec.object2(encoder, decoder, JsonCodec.field("supplierId", JsonCodec.string), JsonCodec.field("shopId", JsonCodec.string));

let Codecs = {
  encoder: encoder,
  decoder: decoder,
  value: value
};

function encode(state) {
  return QueryString.stringify(JsonCodec.encodeWith(state, value));
}

function decode(query) {
  let match = JsonCodec.decodeWith(QueryString.parse(query), value);
  if (match.TAG !== "Ok") {
    return [
      undefined,
      undefined
    ];
  }
  let match$1 = match._0;
  return [
    match$1.supplierId,
    match$1.shopId
  ];
}

let CreateOrder = {
  Codecs: Codecs,
  encode: encode,
  decode: decode
};

export {
  CreateOrder,
}
/* value Not a pure module */
